import request from '../services/request';
import { PATH } from './path';
// 是否新用户
export const requestIsNew = async params => {
  return request({
    url: PATH.base.isNew,
    method: 'get',
    params
  });
};

// 授权校验
export const requestAuth = async params => {
  console.log('data:', params);
  return request({
    url: PATH.base.check,
    method: 'get',
    params
  });
};
// 计费方式获取
export const requestBillTypeList = async params => {
  return request({
    url: PATH.base.billTypeList,
    method: 'get',
    params
  });
};
